<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			Téléphonez au cabinet d’Elisabeth Borne
		</h3>

		<p>
			Que diriez-vous d’un rapide coup de fil au Ministère pour rappeler au gouvernement ses engagements&nbsp;? C’est simple, mais efficace&nbsp;: il verra que la pression citoyenne est là&nbsp;!
		</p>

		<ol>
			<li>
				Appelez le <a href="tel:0140812122" @click="track"><nobr>01 40 81 21 22</nobr></a>
			</li>

			<li>
				Expliquez, de façon aimable, que vous attendez une réaction digne de ce nom d’Elisabeth Borne face à la déforestation importée. Faire sortir la France des agrocarburants de 1ère génération est une nécessité.
				<br/>
				Voici un exemple de phrases à dire au standard&nbsp;:
				<br/>
				«&nbsp;<em>
					Bonjour, Je m'appelle Claude et j’aimerais faire part de ma préoccupation pour la déforestation à Elisabeth Borne. Comme vous travaillez au Cabinet du ministère, vous êtes la personne idéale pour répondre à mes demandes. J’aimerais faire passer à Elisabeth Borne un message simple. J’ai vu que le gouvernement essaie de maintenir l’avantage fiscal sur l’huile de palme dans les agrocarburants. C’est une hérésie&nbsp;! Il faut empêcher sortir de l’huile de palme et vite. Pouvez-vous lui transmettre mon message&nbsp;? Merci&nbsp;!
				</em>&nbsp;»
			</li>
			<li>
				Une fois l’appel terminé, partagez ce post sur Twitter
			</li>
		</ol>

	</div>
</template>

<script>
export default {
	methods: {
		track() {
			this.$trackEvent("click", "telephone elysee")
			this.$count()
		},
	}
}
</script>